// src/pages/Home.js
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import {
  Mail,
  Linkedin,
  Github,
  FileText,
  ArrowUpRight,
  Globe,
  Layers,
  Code2,
  Cpu,
  Activity,
  Fingerprint,
  Terminal,
  Plus,
  Monitor,
  Boxes,
  Code,
  Rocket,
  ShieldCheck,
  Box,
  MoveRight,
  Award,
  Building2,
  History,
  Zap,
  ArrowDown,
  Database,
  BarChart3,
  HardHat,
  Workflow,
  ArrowRight,
  Send,
  Settings,
} from 'lucide-react'
import profile from '../Images/Profile.png'
import focus360 from '../Images/360logo.png'

import Navbar from '../components/Navbar'
import focuslogo from '../Images/Focus Logo.jpg'
import { Helmet } from 'react-helmet-async'
import SEO from './SEO'
import talkytoonLogo from "../Images/TOKOlogo512.png"
import EvalLogo from "../Images/EvalNDT LOGO.png"

const focusGroupCompanies = [
  {
    name: 'Focus Inspection Technology',
    tagline:
      'Ensuring Integrity Through Advanced NDT. Specialist in Advanced NDT Solutions, Certification & Training Programs.',
    link: 'https://focusinspectiontechnology.com/',
    logo: focuslogo,
    type: 'group',
  },
  {
  name: 'Focus NDT Innovations',
  description: 'R&D wing focused on developing proprietary ultrasonic sensors and robotic inspection crawlers for hazardous environments.',
  // link: '#', 
  logo: focuslogo, // Use your preferred logo variable
  type: 'group',
},
  {
    name: 'Focusin360',
    tagline:
      'Complete Digital NDT Platform connecting certified professionals, jobs, and AI-powered inspection tools.',
    link: 'https://focusin360.com',
    logo: focus360,
    type: 'group',
  },
  {
    name: 'Focus Institute of NDT Technology',
    tagline: 'Training & certification programs in Non-Destructive Testing.',
    link: 'https://focus-institute.web.app/',
    logo: focuslogo,
    type: 'group',
  },
]

const featuredProjects = [
  {
    title: 'Focus Inspection Technology',
    description:
      'Industrial inspection and calibration platform with a secure client portal for reporting and analytics.',
    // link: '/tab/projects/focus-inspection-technology',
  },
  {
    title: 'FocusIn360 SaaS',
    description:
      'Cloud-based inspection and calibration platform for asset management, analytics, and predictive maintenance.',
    // link: '/tab/projects/focusin360-saas',
  },
  {
    title: 'Focus Portal Client & Admin',
    description:
      'Centralized SaaS portal to manage inspection workflows, assets, and reporting dashboards for clients and admins.',
    // link: '/tab/projects/focus-portal-client-and-admin',
  },
]

const ventures = [
  {
    name: 'JobDirectly',
    tagline: 'Direct hiring platform connecting talent & companies.',
    link: 'https://jobdirectly.com',
    logo: 'https://jobdirectly.com/static/media/JD_Logo.9d693e5593d7d89a9bc4.png',
    type: 'venture',
  },
  {
    name: 'EvalNDT',
    tagline: 'Digital NDT evaluation & inspection analytics platform.',
    link: 'https://evalndt-4c0ea.web.app/',
    logo: EvalLogo,
    type: 'venture',
  },
  {
    name: 'TalkyToon',
    tagline: 'Kids learning & storytelling animation platform.',
    link: 'https://talkytoon.com',
    logo: talkytoonLogo,
    type: 'venture',
  },
]

const ecosystemCompanies = [...focusGroupCompanies, ...ventures]

export default function Home() {
  useEffect(() => {
    document.title = 'Omkar More'
    const descriptionMeta = document.querySelector('meta[name="description"]')
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        'content',
        'IT & NDT Specialist. Enhancing industrial operations with scalable IT solutions, custom website development, and certified NDT services.',
      )
    }
    const keywordsMeta = document.querySelector('meta[name="keywords"]')
    if (keywordsMeta) {
      keywordsMeta.setAttribute(
        'content',
        'IT & NDT Specialist. Enhancing industrial operations with scalable IT solutions, custom website development, and certified NDT services.',
      )
    }
  }, [])

  const featuredVentures = ecosystemCompanies
    .filter((c) => c.type === 'venture')
    .slice(0, 4)
  return (
    <main className="bg-white text-gray-900 font-sans">
      {/* ===== Hero Section ===== */}
      {/* ===== Hero Section ===== */}
      {/* ===== Hero Section ===== */}
      <section className="relative min-h-screen bg-[#FDFDFD] pt-20 md:pt-20 pb-12 overflow-hidden border-b border-slate-200">
        {/* Background Grid Pattern */}
        <div
          className="absolute inset-0 opacity-[0.03] pointer-events-none"
          style={{
            backgroundImage:
              'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        />

        <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
          {/* Top Identification Row */}
          <div className="flex flex-col sm:flex-row justify-between items-center mb-12 border-b border-slate-200 pb-4 sm:pb-6 gap-3 sm:gap-4">
            {/* Left: Current Role & Expertise */}
            <div className="flex items-center gap-2 sm:gap-3">
              <span className="w-2 h-2 rounded-full bg-cyan-600 animate-pulse inline-block" />
              <span className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-slate-600">
                Role:{' '}
                <strong className="text-cyan-700">
                  Founder & Technical Lead
                </strong>
              </span>
            </div>

            {/* Center: Core Expertise */}
            <div className="hidden sm:flex items-center gap-2 sm:gap-3">
              <span className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-slate-500">
                Expertise:{' '}
                <strong className="text-slate-700">
                  Industrial NDT · Cloud Platforms · EdTech
                </strong>
              </span>
            </div>

            {/* Right: Reference / Year */}
            <span className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-slate-400 mt-2 sm:mt-0">
              Established: <strong className="text-slate-700">2018</strong>
            </span>
          </div>

          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
            {/* SIDEBAR / IMAGE - Order 1 on Mobile, Order 2 on Desktop */}
            {/* Added mt-10 for mobile to move it down from the top edge */}
            <div className="w-full lg:w-96 flex-shrink-0 order-1 lg:order-2 mt-10 lg:mt-0">
              <div className="sticky top-24 space-y-6 md:space-y-8">
                {/* Profile Frame */}
                <div className="relative group w-full max-w-sm sm:max-w-md mx-auto lg:mx-0">
                  {/* 1. Animated Tech Border */}
                  <div className="absolute -inset-6 border border-dashed border-cyan-600/20 rounded-[3rem] lg:animate-[spin_30s_linear_infinite] pointer-events-none" />

                  {/* 2. The Dossier Image Card */}
                  <div className="relative aspect-[4/5] sm:aspect-[2/3] rounded-[2.5rem] overflow-hidden bg-slate-100 border-2 border-slate-950 shadow-[0_20px_50px_rgba(0,0,0,0.2)]">
                    {/* Precision Viewfinder Accents */}
                    <div className="absolute top-8 left-8 w-8 h-8 border-t-2 border-l-2 border-cyan-500/40 z-10" />
                    <div className="absolute bottom-8 right-8 w-8 h-8 border-b-2 border-r-2 border-cyan-500/40 z-10" />

                    <img
                      src={profile}
                      alt="Omkar More"
                      className="w-full h-full object-cover object-[center_5%] transition-transform duration-1000 group-hover:scale-110"
                    />

                    {/* Integrated Tech Label */}
                    <div className="absolute bottom-0 inset-x-0 p-8 bg-gradient-to-t from-slate-950/90 via-slate-950/50 to-transparent">
                      <div className="flex flex-col gap-2 text-left">
                        {/* <span className="font-mono text-[10px] text-cyan-400 uppercase tracking-[0.4em]">
                    Founder & Technical Architect
                  </span> */}

                        <h3 className="text-white font-extrabold text-2xl uppercase tracking-widest leading-none">
                          Omkar More
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Quick Data Points */}
                <div className="grid grid-cols-1 gap-5 pt-8 border-t-2 border-slate-950/10 max-w-sm sm:max-w-md mx-auto lg:mx-0">
                  {/* Engineering Degree Row */}
                  <div className="group flex flex-col gap-1">
                    <div className="flex justify-between items-center">
                      {/* Changed to slate-900 and font-black for maximum visibility */}
                      <span className="font-mono text-[11px] font-black text-slate-900 uppercase tracking-[0.2em]">
                        Academic Base
                      </span>
                      <span className="h-px flex-grow mx-4 bg-slate-200 group-hover:bg-cyan-200 transition-colors" />
                      <span className="font-bold text-xs md:text-sm text-slate-600 uppercase">
                        BE / IT Engineer
                      </span>
                    </div>
                  </div>

                  {/* NDT Certification Row */}
                  <div className="group flex flex-col gap-1">
                    <div className="flex justify-between items-center">
                      {/* Changed to cyan-700 to distinguish the category clearly */}
                      <span className="font-mono text-[11px] font-black text-cyan-700 uppercase tracking-[0.2em]">
                        NDT Authority
                      </span>
                      <span className="h-px flex-grow mx-4 bg-slate-200 group-hover:bg-cyan-200 transition-colors" />
                      <div className="flex flex-col items-end">
                        <span className="font-black text-xs md:text-sm text-slate-950 uppercase leading-none">
                          PCN LEVEL 2
                        </span>
                        <span className="text-[10px] font-extrabold text-cyan-600 uppercase tracking-tighter">
                          UT · PAUT Certified
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Founder Row */}
                  {/* Founder Row - Now Clickable */}
                  <Link
                    to="/ventures"
                    className="group flex flex-col gap-2 p-3 bg-slate-50 border border-slate-100 rounded-xl transition-all hover:border-cyan-400 hover:bg-white hover:shadow-md active:scale-[0.98] block"
                  >
                    <div className="flex justify-between items-center">
                      {/* High Contrast Label */}
                      <span className="font-mono text-[11px] font-black text-slate-900 uppercase tracking-[0.2em]">
                        Foundership
                      </span>

                      <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-full border border-slate-200 shadow-sm group-hover:border-cyan-200 transition-colors">
                        {/* Status Indicator */}
                        <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />

                        {/* High Contrast Value */}
                        <span className="font-black text-xs md:text-sm text-slate-900 tracking-tight">
                          4 ACTIVE VENTURES
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>

                {/* Technical Icons */}
                <div className="flex justify-center lg:justify-start gap-6 opacity-20 pt-2">
                  <Layers size={18} />
                  <Cpu size={18} />
                  <Fingerprint size={18} />
                </div>
              </div>
            </div>

            {/* MAIN CONTENT - Order 2 on Mobile, Order 1 on Desktop */}
            {/* MAIN CONTENT - Order 2 on Mobile, Order 1 on Desktop */}
            <div className="flex-grow lg:max-w-4xl order-2 lg:order-1 mt-16 lg:mt-0">
              <div className="flex flex-col lg:flex-row gap-12">
                {/* 1. THE STATUS SIDEBAR (Desktop Only) */}

                {/* 2. CORE HEADING & BRIEF */}
                <div className="flex-grow text-left">
                  <div className="mb-10">
                    <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-slate-950 tracking-tight mb-4 whitespace-nowrap">
                      INDUSTRIAL <span className="text-cyan-600 italic">.</span>
                      TECH
                    </h1>

                    <div className="h-1 w-24 bg-slate-900" />
                  </div>

                  <div className="mb-12">
                    <h2 className="text-2xl md:text-4xl font-extrabold text-slate-900 leading-[1.1] mb-6">
                      Engineering the bridge between <br />
                      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-slate-400">
                        Industrial Reality & Digital Intelligence.
                      </span>
                    </h2>

                    {/* THE CONSOLE BOX */}
                    <div className="bg-slate-50 border-l-4 border-slate-950 p-6 md:p-8 rounded-r-2xl mb-12">
                      <p className="text-slate-600 text-base md:text-lg leading-relaxed font-medium">
                        I design and build systems that convert raw NDT
                        inspection data — ultrasonic, phased array, and field
                        measurements — into structured, cloud-ready intelligence
                        for faster decisions, safer assets, and zero ambiguity.
                      </p>
                    </div>

                    {/* 3. THE STEPPED SERVICES */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                      {[
                        {
                          label: 'Layer 01',
                          title: 'Software Engineering',
                          info: 'Cloud Platforms · SaaS · AI Pipelines',
                        },
                        {
                          label: 'Layer 02',
                          title: 'Industrial NDT',
                          info: 'UT · PAUT · Inspection Workflows',
                        },
                        {
                          label: 'Layer 03',
                          title: 'Product & Education',
                          info: 'EdTech · Training · Certification Systems',
                        },
                      ].map((item, i) => (
                        <div
                          key={i}
                          className="group p-5 border border-slate-100 rounded-xl 
                         hover:shadow-xl hover:shadow-slate-200/50 
                         transition-all bg-white"
                        >
                          <span className="font-mono text-[9px] font-black text-cyan-600 uppercase tracking-widest block mb-2">
                            {item.label}
                          </span>
                          <h3 className="font-black text-sm text-slate-950 uppercase mb-1">
                            {item.title}
                          </h3>
                          <p className="text-[10px] font-bold text-slate-400 uppercase">
                            {item.info}
                          </p>
                        </div>
                      ))}
                    </div>

                    {/* 4. ACTION BAR */}
                    <div className="flex flex-col sm:flex-row items-center gap-6">
                      <Link
                        to="/contact"
                        className="w-full sm:w-auto flex items-center justify-center gap-4 
                       bg-slate-950 text-white px-10 py-5 rounded-full 
                       font-black text-xs uppercase tracking-[0.2em] 
                       hover:scale-[1.02] active:scale-95 
                       transition-all shadow-xl shadow-slate-300"
                      >
                        Initiate Collaboration <ArrowRight size={16} />
                      </Link>

                      <div className="flex gap-10">
                        <div className="text-left">
                          <span className="block text-[9px] font-black text-slate-300 uppercase mb-1">
                            Focus Areas
                          </span>
                          <span className="text-[10px] font-mono text-slate-900 font-bold uppercase tracking-tight">
                            NDT · IT · Digital Products
                          </span>
                        </div>

                        <div className="text-left">
                          <span className="block text-[9px] font-black text-slate-300 uppercase mb-1">
                            Base
                          </span>
                          <span className="text-[10px] font-mono text-slate-900 font-bold uppercase tracking-tight">
                            Mumbai, INDIA
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ===== Professional Highlights / Stats ===== */}
      {/* ===== Professional Highlights / Stats ===== */}
      {/* ===== Professional Highlights / Stats ===== */}
      <section
        className="bg-white py-16 md:py-32 overflow-hidden relative"
        aria-label="Professional Profile"
      >
        {/* Background Tech-Industrial Blend */}
        <div className="absolute inset-0 z-0 opacity-[0.07] pointer-events-none">
          {/* The Industrial Image */}
          <img
            src="https://images.unsplash.com/photo-1513828583688-c52646db42da?auto=format&fit=crop&q=80"
            alt="Industrial Engineering"
            className="w-full h-full object-cover grayscale"
          />
          {/* The Tech Overlay (Blueprint Grid) */}
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:40px_40px]"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="flex flex-col lg:flex-row gap-12 md:gap-16 lg:gap-24 items-start">
            {/* Left Side: Content & Branding */}
            <div className="w-full lg:w-1/2">
              <h2 className="text-cyan-700 text-[10px] md:text-xs font-black uppercase tracking-[0.3em] md:tracking-[0.4em] mb-4 md:mb-6 flex items-center gap-3">
                <span className="w-12 h-[2px] bg-cyan-700"></span>
                Professional Profile
              </h2>

              <h3 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-slate-950 tracking-tighter leading-[0.95] md:leading-[0.9] mb-6 md:mb-8">
                Architecting Industrial <br className="hidden sm:block" />
                <span className="text-slate-300 italic">Efficiency.</span>
              </h3>

              <div className="space-y-5 md:space-y-6 text-slate-600 text-base md:text-lg leading-relaxed max-w-xl">
                <p>
                  Leveraging a dual-sector mastery of{' '}
                  <strong className="text-slate-900 font-bold border-b-2 border-cyan-500/20">
                    IT innovation
                  </strong>{' '}
                  and{' '}
                  <strong className="text-slate-900 font-bold border-b-2 border-cyan-500/20">
                    industrial NDT expertise
                  </strong>
                  .
                </p>
                <p>
                  I deliver digital solutions that optimize safety and
                  compliance across global industries, bridging the gap between
                  legacy operations and cloud-scale technology.
                </p>
              </div>

              <div className="mt-10 md:mt-12 flex flex-wrap gap-x-6 md:gap-x-8 gap-y-4">
                {['Journey', 'Expertise', 'Projects'].map((link) => (
                  <Link
                    key={link}
                    to={`/${link.toLowerCase()}`}
                    className="group flex items-center gap-2 text-xs font-black uppercase tracking-widest text-slate-950 hover:text-cyan-700 transition-colors p-1 -ml-1"
                  >
                    {link}
                    <MoveRight
                      size={14}
                      className="group-hover:translate-x-2 transition-transform duration-300"
                    />
                  </Link>
                ))}
              </div>
            </div>

            {/* Right Side: Dual Image & Stats Integration */}
            <div className="w-full lg:w-1/2">
              <div className="relative rounded-[1.5rem] md:rounded-[2.5rem] overflow-hidden bg-slate-100 border border-slate-200 shadow-2xl">
                {/* Top Visual: The Tech-Industrial Hybrid Image */}
                <div className="h-48 md:h-64 relative overflow-hidden group">
                  {/* Image 1: Industrial Structure */}
                  <img
                    src="https://images.unsplash.com/photo-1561471828-96e54774b225?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt="Industrial Plant"
                    className="absolute inset-0 w-full h-full object-cover grayscale brightness-50 group-hover:grayscale-0 transition-all duration-1000"
                  />
                  {/* Image 2: Technology Overlay (Circuitry/Data) */}
                  <img
                    src="https://plus.unsplash.com/premium_photo-1678566111481-8e275550b700?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt="Technology Circuit"
                    className="absolute inset-0 w-full h-full object-cover mix-blend-screen opacity-40 group-hover:opacity-60 transition-opacity duration-700"
                  />
                  {/* Decorative Glassmorphism Overlay */}
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-1 gap-px bg-slate-200">
                  {[
                    {
                      label: 'Experience',
                      value: '5+ Years',
                      desc: 'Industrial IT & NDT Operations',
                      icon: History,
                    },
                    {
                      label: 'Qualifications',
                      value: '10+ Certs',
                      desc: 'Professional Trainings',
                      icon: Award,
                    },
                    {
                      label: 'Ecosystem',
                      value: '5+ Firms',
                      desc: 'Global Collaborations',
                      icon: Building2,
                    },
                  ].map((stat, i) => (
                    <div
                      key={i}
                      className="bg-white p-7 md:p-10 flex items-center justify-between hover:bg-slate-50 transition-all duration-300"
                    >
                      <div>
                        <p className="text-[9px] md:text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 mb-1">
                          {stat.label}
                        </p>
                        <h4 className="text-3xl md:text-4xl font-extrabold text-slate-950 tracking-tight">
                          {stat.value}
                        </h4>
                        <p className="text-slate-500 text-xs md:text-sm mt-1 uppercase tracking-wider">
                          {stat.desc}
                        </p>
                      </div>
                      <stat.icon
                        className="text-cyan-700/20"
                        size={36}
                        strokeWidth={1}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Companies & Ventures Preview ===== */}
      {/* ===== Focus Group & Ventures ===== */}
      {/* ===== Focus Group & Ventures ===== */}
      <div className="bg-white font-sans antialiased text-slate-900 overflow-hidden">
        {/* SECTION 1: FOCUS GROUP */}
        {/* SECTION 1: FOCUS GROUP */}
{/* SECTION 1: FOCUS GROUP */}
{/* SECTION 1: FOCUS GROUP - CONSISTENT INDUSTRIAL GRID */}
{/* SECTION 1: FOCUS GROUP - 4 CARD SYSTEM */}
<section className="py-20 md:py-32 bg-white relative overflow-hidden">
  
  {/* 1. Global Background Visuals */}
  <div className="absolute top-0 right-0 w-full lg:w-2/3 h-full opacity-[0.08] pointer-events-none">
    <img
      src="https://images.unsplash.com/photo-1597057435443-8a51eeb5538f?q=80&w=1374&auto=format&fit=crop"
      alt=""
      className="w-full h-full object-cover grayscale"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-white via-white/60 to-transparent"></div>
  </div>



  <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
    <header className="mb-20 border-l-4 border-cyan-700 pl-6 md:pl-8">
      <h2 className="text-slate-400 text-[10px] md:text-xs font-black uppercase tracking-[0.4em] mb-4">
        Industrial Portfolio
      </h2>
      <h3 className="text-4xl md:text-7xl font-extrabold tracking-tighter text-slate-950 mb-6 md:mb-8">
        Focus Group <span className="text-slate-300">&</span> Co.
      </h3>
    </header>

    {/* 3. CONSISTENT GRID: 4 Unique Static Images */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
      {focusGroupCompanies.map((company, idx) => {
        // Unique industrial images mapped to each business unit
        const cardImages = [
          "https://focusinspectiontechnology.com/static/media/Team.c818fced1e5c01114825.jpeg", // Tech/NDT
          "https://focusinspectiontechnology.com/static/media/Inhouse1.b8cdf2836f037dab4857.png", // SaaS/Digital
          "https://images.unsplash.com/photo-1682208703268-d8027180acee?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Institute/Training
          "https://images.unsplash.com/photo-1591570548468-752aece6ef6d?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"  // Innovations/R&D
        ];

        return (
          <div
            key={idx}
            className="group relative bg-white border border-slate-200 rounded-[2.5rem] shadow-sm hover:shadow-2xl hover:border-cyan-500/30 transition-all duration-500 overflow-hidden flex flex-col h-full"
          >
            {/* Visual Header: Static Unique Image */}
            <div className="h-64 w-full overflow-hidden relative border-b border-slate-100">
              <img 
                src={cardImages[idx]} 
                className="w-full h-full object-cover  group-hover:scale-105 transition-all duration-700" 
                alt={company.name} 
              />
              <div className="absolute inset-0 bg-slate-900/10 group-hover:bg-transparent transition-colors"></div>
              
              {/* Floating ID Tag */}
              <div className="absolute top-6 left-6 flex items-center gap-3">
                <span className="bg-white/90 backdrop-blur-md text-slate-900 text-xs font-black px-4 py-2 rounded-full shadow-lg italic">
                  0{idx + 1}
                </span>
              </div>

              {/* Status Badge */}
              <div className="absolute top-6 right-6">
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/90 backdrop-blur-md border border-white/20 shadow-lg">
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-600 animate-pulse"></span>
                  <span className="text-[9px] font-black text-slate-900 uppercase tracking-widest">
                    Operational
                  </span>
                </div>
              </div>
            </div>

            {/* Content Body */}
            <div className="p-8 md:p-10 flex flex-col flex-grow">
              <div className="flex items-center gap-4 mb-6">
<img
  src={company.logo}
  alt={company.name}
  className="w-16 h-16 object-contain"
/>

                <h4 className="text-2xl md:text-3xl font-bold text-slate-950 tracking-tight">
                  {company.name}
                </h4>
              </div>

              <p className="text-slate-500 text-base leading-relaxed mb-10 flex-grow">
                {company.tagline || company.description}
              </p>

              {/* Bottom Row: Interaction & Tags */}
              <div className="mt-auto pt-8 border-t border-slate-100 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
                <div className="flex flex-wrap gap-2">
                  <span className="text-[10px] font-bold text-slate-600 bg-slate-50 px-3 py-1.5 rounded-lg uppercase tracking-wider border border-slate-100">
                    {idx === 1 ? 'Digital Asset' : 'Heavy Industrial'}
                  </span>
                  <span className="text-[10px] font-bold text-cyan-700 bg-cyan-50 px-3 py-1.5 rounded-lg uppercase tracking-wider border border-cyan-100">
                    Tier 1
                  </span>
                </div>

                <a
                  href={company.link}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center gap-4 px-6 py-3 rounded-full bg-slate-950 text-white font-bold text-xs uppercase tracking-[0.2em] group/btn hover:bg-cyan-700 transition-all shadow-lg"
                >
                  Portal
                  <ArrowUpRight size={18} className="group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform" />
                </a>
              </div>
            </div>
          </div>
        );
      })}
    </div>

    {/* Global Footer Meta */}
    <div className="mt-20 flex items-center justify-center gap-4 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
      <div className="h-[1px] w-12 bg-slate-200"></div>
      <Plus size={14} className="text-cyan-700" />
      <span>Established Industrial Ecosystem</span>
      <div className="h-[1px] w-12 bg-slate-200"></div>
    </div>
  </div>
</section>

        {/* SECTION 2: INDEPENDENT VENTURES */}
        <section className="py-20 md:py-32 bg-slate-950 relative overflow-hidden">
          {/* Visual Background Blend - High-Tech Texture */}
          <div className="absolute inset-0 opacity-20 pointer-events-none">
            <img
              src="https://images.unsplash.com/photo-1506526794364-ba711a0d97fc?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt=""
              className="w-full h-full object-cover mix-blend-overlay"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-transparent to-slate-950"></div>
          </div>

          <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
            <header className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8">
              <div className="max-w-2xl">
                <div className="flex items-center gap-2 text-cyan-400 text-[10px] font-black uppercase tracking-[0.4em] mb-4">
                  <Rocket size={14} strokeWidth={3} /> Founder & Architect
                </div>
                <h3 className="text-4xl md:text-6xl font-extrabold tracking-tighter text-white mb-6">
                  Independent <br />
                  <span className="text-slate-500 text-3xl md:text-5xl">
                    Venture Portfolio.
                  </span>
                </h3>
                <p className="text-slate-400 text-lg md:text-xl font-medium leading-relaxed">
                  Proprietary platforms conceived and scaled under my
                  leadership. I build digital solutions for global markets.
                </p>
              </div>

              <Link
                to="/ventures"
                className="hidden md:flex items-center gap-3 text-white font-bold text-sm tracking-widest group border-b-2 border-cyan-500 pb-2 transition-all hover:border-white"
              >
                VIEW FULL VENTURE LAB{' '}
                <ArrowUpRight
                  size={20}
                  className="text-cyan-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                />
              </Link>
            </header>

            {/* The Bento Grid with Glassmorphism */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
  {featuredVentures.map((venture, idx) => (
    <a
      key={idx}
      href={venture.link} // Ensure your venture object has a 'url' property
      target="_blank"
      rel="noopener noreferrer"
      className="group flex flex-col justify-between p-8 rounded-[2.5rem] bg-white/5 border border-white/10 hover:bg-white/10 hover:border-cyan-500/50 transition-all duration-500 min-h-[300px] backdrop-blur-sm cursor-pointer"
    >
      <div>
        <div className="flex justify-between items-start mb-8">
          <div className="w-14 h-14 bg-white rounded-2xl shadow-lg flex items-center justify-center p-3 transition-transform group-hover:scale-110">
            <img
              src={venture.logo}
              alt={venture.name}
              className="w-full h-full object-contain"
            />
          </div>
          <ShieldCheck
            size={18}
            className="text-cyan-500 opacity-50 group-hover:opacity-100 transition-opacity"
          />
        </div>

        <h4 className="text-2xl font-bold text-white mb-2 tracking-tight group-hover:text-cyan-400 transition-colors">
          {venture.name}
        </h4>
        <p className="text-slate-400 text-xs font-medium leading-relaxed line-clamp-2">
          {venture.tagline}
        </p>
      </div>

      <div className="pt-6 border-t border-white/10 flex items-center justify-between">
        <span className="text-[9px] font-black uppercase tracking-widest text-cyan-400 flex items-center gap-2">
          Founded By Me 
          <span className="opacity-0 group-hover:opacity-100 transition-all transform translate-x-[-10px] group-hover:translate-x-0">
            →
          </span>
        </span>
        <Terminal
          size={14}
          className="text-slate-600 group-hover:text-white transition-colors"
        />
      </div>
    </a>
  ))}
</div>

            {/* Footer Context */}
            <footer className="mt-12 hidden md:flex items-center gap-3 text-slate-500 text-[10px] font-bold uppercase tracking-widest">
              <Box size={14} className="text-cyan-700" />
              <span>
                Full Product Lifecycle Ownership: Ideation to Deployment
              </span>
            </footer>
          </div>
        </section>
      </div>

      {/* ===== Call to Action ===== */}
      {/* ===== High-Impact Call to Action ===== */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 md:py-24">
        <div className="relative overflow-hidden bg-slate-950 rounded-[2rem] md:rounded-[3rem] shadow-2xl">
          {/* Background Decorative Elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-600/20 blur-[100px] -mr-48 -mt-48" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-slate-800/50 blur-[80px] -ml-32 -mb-32" />

          <div className="relative z-10 px-8 py-12 md:p-16 lg:p-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Left: Content Area */}
              <div className="text-left">
                <h2
                  id="cta-heading"
                  className="text-4xl md:text-6xl font-black text-white leading-[1.1] mb-6 tracking-tight"
                >
                  Ready to <span className="text-cyan-400">Collaborate?</span>
                </h2>

                <p className="text-slate-400 text-lg md:text-xl leading-relaxed max-w-xl mb-10 font-medium">
                  Bridging <span className="text-white">IT innovation</span>{' '}
                  with{' '}
                  <span className="text-white">industrial NDT expertise</span>.
                  Let's discuss your next breakthrough project or industrial
                  solution.
                </p>

                {/* Quick Stats/Badges for Credibility */}
                <div className="flex flex-wrap gap-4 pt-6 border-t border-slate-800">
                  <div className="flex flex-col">
                    <span className="text-white font-black text-lg">2026</span>
                    <span className="text-[10px] text-slate-500 uppercase tracking-widest">
                      Active Cycle
                    </span>
                  </div>
                  <div className="w-px h-10 bg-slate-800 mx-2 hidden sm:block" />
                  <div className="flex flex-col">
                    <span className="text-white font-black text-lg">
                      Global
                    </span>
                    <span className="text-[10px] text-slate-500 uppercase tracking-widest">
                      Deployment
                    </span>
                  </div>
                </div>
              </div>

              {/* Right: Modern Navigation Buttons */}
              <div className="flex flex-col gap-4 w-full">
                <Link
                  to="/journey"
                  className="group flex items-center justify-between bg-white hover:bg-cyan-400 p-6 rounded-2xl transition-all duration-300"
                >
                  <div className="flex flex-col text-left">
                    <span className="font-black text-slate-950 text-xl uppercase tracking-tighter">
                      My Journey
                    </span>
                    <span className="text-xs font-bold text-slate-500 group-hover:text-cyan-900 transition-colors">
                      Professional Timeline & Milestones
                    </span>
                  </div>
                  <ArrowRight
                    size={24}
                    className="text-slate-950 -translate-x-2 opacity-0 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
                  />
                </Link>

                <Link
                  to="/expertise"
                  className="group flex items-center justify-between bg-slate-900 border border-slate-800 hover:border-cyan-500/50 p-6 rounded-2xl transition-all duration-300"
                >
                  <div className="flex flex-col text-left">
                    <span className="font-black text-white text-xl uppercase tracking-tighter">
                      Expertise
                    </span>
                    <span className="text-xs font-bold text-slate-500">
                      Technical Stack & NDT Authority
                    </span>
                  </div>
                  <Layers
                    size={24}
                    className="text-cyan-500 opacity-50 group-hover:opacity-100 transition-opacity"
                  />
                </Link>

                <Link
                  to="/contact"
                  className="group flex items-center justify-center gap-3 bg-cyan-600 hover:bg-cyan-500 text-white p-6 rounded-2xl font-black text-sm uppercase tracking-[0.2em] shadow-lg shadow-cyan-900/20 transition-all active:scale-95"
                >
                  Get In Touch
                  <Send
                    size={18}
                    className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
